import React, { useState } from 'react';
import InventoryDashboard from "../components/inventory/InventoryDashboard";
import Menu from "../components/common/menu/Menu";
import Sidebar from "../components/common/menu/Sidebar";
import FiguresDashboard from "../components/figures/FiguresDashboard";
import {Card, CardBody} from "@material-tailwind/react";
import InventoryValueCard from "../components/inventory/analytics/InventoryValueCard";
import TotalPersonalCostCard from "../components/inventory/analytics/TotalPersonalCostCard";
import TotalInventoryCostCard from "../components/inventory/analytics/TotalInventoryCostCard";
import TotalSalesRevenueCard from "../components/inventory/analytics/TotalSalesRevenueCard";
import CostOfGoodsSoldCard from "../components/inventory/analytics/CostOfGoodsSoldCard";
import GrossProfitCard from "../components/inventory/analytics/GrossProfitCard";
import OperatingExpensesCard from "../components/inventory/analytics/OperatingExpensesCard";
import NetProfitCard from "../components/inventory/analytics/NetProfitCard";
import ProfitMarginCard from "../components/inventory/analytics/ProfitMarginCard";
import FinancialReportCard from "../components/inventory/analytics/FinancialReportCard";
import DailyProfitCard from "../components/inventory/analytics/DailyProfitCard";
import TotalInventoryCostCardFigure from "../components/figures/analytics/TotalInventoryCostCardFigure";
import InventoryValueCardFigure from "../components/figures/analytics/InventoryValueCardFigure";
import TotalSalesRevenueCardFigure from "../components/figures/analytics/TotalSalesRevenueCardFigure";
import CostOfGoodsSoldCardFigure from "../components/figures/analytics/CostOfGoodsSoldCardFigure";
import GrossProfitCardFigure from "../components/figures/analytics/GrossProfitCardFigure";
import ProfitMarginCardFigure from "../components/figures/analytics/ProfitMarginCardFigure";
import FinancialReportCardFigure from "../components/figures/analytics/FinancialReportCardFigure";
import DailyProfitCardFigure from "../components/figures/analytics/DailyProfitCardFigure";


function FiguresPage() {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const now = new Date();
    const [analyticsPeriod, setAnalyticsPeriod] = useState({
        mode: 'month',
        year: now.getFullYear(),
        quarter: Math.floor(now.getMonth() / 3) + 1,
        month: now.getMonth() + 1,
    });

    const toggleSidebar = (isOpen) => {
        setSidebarOpen(isOpen);
    };

    const currentYear = now.getFullYear();
    const availableYears = Array.from(
        { length: currentYear - 2023 },
        (_, index) => 2024 + index
    );

    const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];

    const updateAnalyticsPeriod = (updates) => {
        setAnalyticsPeriod((current) => {
            const next = {
                ...current,
                ...updates,
            };

            if (next.year === currentYear) {
                next.quarter = Math.min(next.quarter, Math.floor(now.getMonth() / 3) + 1);
                next.month = Math.min(next.month, now.getMonth() + 1);
            }

            return next;
        });
    };

    const isQuarterDisabled = (quarter, year) => {
        if (year < currentYear) return false;
        if (year > currentYear) return true;

        return quarter > Math.floor(now.getMonth() / 3) + 1;
    };

    const isMonthDisabled = (month, year) => {
        if (year < currentYear) return false;
        if (year > currentYear) return true;

        return month > now.getMonth() + 1;
    };

    return (
        <div className="overflow-hidden dark:bg-dark-950">
            <div className="block md:hidden">
                <Menu sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
            </div>

            <div className="hidden md:block ">
                <Sidebar />
            </div>

            <div className="md:ml-[15rem] bg-light-blue-50 relative dark:bg-dark-950">
                <div className="absolute inset-0 opacity-[0.04] dark:opacity-0" style={{
                    backgroundImage: 'url(https://i.ibb.co/9kYFDXtW/background-manga.jpg)',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                }}></div>

                <div className="relative">
                    <div className="flex justify-center items-center">
                        <div className="w-full mt-8 lg:mt-20 mb-56" style={{ maxWidth: '1420px' }}>
                            <div className="mx-2 lg:mx-10">
                                <FiguresDashboard fixedName={true} />
                            </div>

                            <div className="mt-8 mx-2 lg:mx-10">
                                <div className="w-full rounded-lg bg-white dark:bg-dark-900 shadow-lg px-4 py-3">
                                    <div className="flex flex-col xl:flex-row xl:items-center xl:justify-between gap-3">
                                        <div>
                                            <p className="text-sm font-semibold text-gray-900 dark:text-gray-200">Analytics period</p>
                                            <p className="text-xs text-gray-500 dark:text-gray-400">Applies to figures analytics cards</p>
                                        </div>

                                        <div className="flex flex-col sm:flex-row gap-2 sm:items-center sm:justify-end">
                                            {analyticsPeriod.mode !== 'all_time' && (
                                                <select
                                                    value={analyticsPeriod.year}
                                                    onChange={(event) => updateAnalyticsPeriod({ year: Number(event.target.value) })}
                                                    className="w-full sm:w-28 border border-gray-300 dark:border-gray-700 rounded-lg px-3 py-2 bg-white dark:bg-dark-800 text-sm text-gray-800 dark:text-gray-200 focus:outline-none focus:ring-2 focus:ring-cyan-700"
                                                >
                                                    {availableYears.map((year) => (
                                                        <option key={year} value={year}>{year}</option>
                                                    ))}
                                                </select>
                                            )}

                                            {analyticsPeriod.mode === 'quarter' && (
                                                <select
                                                    value={analyticsPeriod.quarter}
                                                    onChange={(event) => updateAnalyticsPeriod({ quarter: Number(event.target.value) })}
                                                    className="w-full sm:w-24 border border-gray-300 dark:border-gray-700 rounded-lg px-3 py-2 bg-white dark:bg-dark-800 text-sm text-gray-800 dark:text-gray-200 focus:outline-none focus:ring-2 focus:ring-cyan-700"
                                                >
                                                    {[1, 2, 3, 4].map((quarter) => (
                                                        <option
                                                            key={quarter}
                                                            value={quarter}
                                                            disabled={isQuarterDisabled(quarter, analyticsPeriod.year)}
                                                        >
                                                            Q{quarter}
                                                        </option>
                                                    ))}
                                                </select>
                                            )}

                                            {analyticsPeriod.mode === 'month' && (
                                                <select
                                                    value={analyticsPeriod.month}
                                                    onChange={(event) => updateAnalyticsPeriod({ month: Number(event.target.value) })}
                                                    className="w-full sm:w-36 border border-gray-300 dark:border-gray-700 rounded-lg px-3 py-2 bg-white dark:bg-dark-800 text-sm text-gray-800 dark:text-gray-200 focus:outline-none focus:ring-2 focus:ring-cyan-700"
                                                >
                                                    {months.map((month, index) => (
                                                        <option
                                                            key={month}
                                                            value={index + 1}
                                                            disabled={isMonthDisabled(index + 1, analyticsPeriod.year)}
                                                        >
                                                            {month}
                                                        </option>
                                                    ))}
                                                </select>
                                            )}

                                            <div className="grid grid-cols-4 w-full sm:w-[356px] rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden bg-white dark:bg-dark-800">
                                                {[
                                                    { value: 'all_time', label: 'All time' },
                                                    { value: 'year', label: 'Year' },
                                                    { value: 'quarter', label: 'Quarter' },
                                                    { value: 'month', label: 'Month' },
                                                ].map(({ value, label }) => (
                                                    <button
                                                        key={value}
                                                        type="button"
                                                        onClick={() => updateAnalyticsPeriod({ mode: value })}
                                                        className={`px-3 py-2 text-sm font-medium transition-colors ${
                                                            analyticsPeriod.mode === value
                                                                ? 'bg-cyan-800 text-white'
                                                                : 'text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-dark-700'
                                                        }`}
                                                    >
                                                        {label}
                                                    </button>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="mt-8 mb-8 mx-2 lg:mx-10 grid grid-cols-1 lg:grid-cols-2 gap-4">
                                <Card className="w-full shadow-lg dark:bg-dark-900">
                                    <CardBody>
                                        <div className="flow-root">
                                            <ul className="divide-y divide-gray-200 dark:divide-gray-800">
                                                <InventoryValueCardFigure
                                                    analyticsPeriod={analyticsPeriod}
                                                    onAnalyticsPeriodChange={updateAnalyticsPeriod}
                                                />
                                                {/*<TotalPersonalCostCard />*/}
                                                <TotalInventoryCostCardFigure
                                                    analyticsPeriod={analyticsPeriod}
                                                    onAnalyticsPeriodChange={updateAnalyticsPeriod}
                                                />
                                                <TotalSalesRevenueCardFigure
                                                    analyticsPeriod={analyticsPeriod}
                                                    onAnalyticsPeriodChange={updateAnalyticsPeriod}
                                                />
                                                <CostOfGoodsSoldCardFigure
                                                    analyticsPeriod={analyticsPeriod}
                                                    onAnalyticsPeriodChange={updateAnalyticsPeriod}
                                                />
                                            </ul>
                                        </div>
                                    </CardBody>
                                </Card>

                                <Card className="w-full shadow-lg dark:bg-dark-900">
                                    <CardBody>
                                        <div className="flow-root">
                                            <ul className="divide-y divide-gray-200 dark:divide-gray-800">
                                                <GrossProfitCardFigure
                                                    analyticsPeriod={analyticsPeriod}
                                                    onAnalyticsPeriodChange={updateAnalyticsPeriod}
                                                />
                                                {/*<OperatingExpensesCard />*/}
                                                {/*<NetProfitCard />*/}
                                                <ProfitMarginCardFigure />
                                                <FinancialReportCardFigure />
                                                <DailyProfitCardFigure />
                                            </ul>
                                        </div>
                                    </CardBody>
                                </Card>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FiguresPage;
